import React from "react";
import { Box, Inline, xcss } from "@atlaskit/primitives";
import { useIntl } from "react-intl";
import { IconButton } from "@atlaskit/button/new";
import TerminalIcon from "@atlaskit/icon-lab/core/terminal";
import CrossIcon from "@atlaskit/icon/core/cross";
import { messages } from "./messages";
import { LocalStorageKey } from "../../clients/localStorage";
import { useSettings } from "../../clients/settings-client";

const bannerContainerStyles = xcss({
  position: "fixed",
  bottom: "space.200",
  left: "space.200",
  zIndex: "tooltip",
});

const bannerStyles = xcss({
  position: "relative",
  backgroundColor: "color.background.warning.bold",
  color: "color.text.inverse",
  paddingBlock: "space.100",
  paddingInline: "space.200",
  borderRadius: "radius.medium",
  font: "font.body.small",
  fontWeight: "font.weight.bold",
  boxShadow: "elevation.shadow.overlay",
  userSelect: "none",
});

const closeButtonStyles = xcss({
  position: "absolute",
  top: "space.negative.150",
  right: "space.negative.150",
});

export const LocalDevBanner = (): React.JSX.Element => {
  const { formatMessage } = useIntl();
  const { localStoredSettings } = useSettings();

  const isLocalDevBannerEnabled = localStoredSettings[LocalStorageKey.LOCAL_DEV_BANNER_ENABLED];

  const [isHidden, setIsHidden] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);

  if (!isLocalDevBannerEnabled || isHidden) {
    return <></>;
  }

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      testId="local-dev-banner-container"
      xcss={bannerContainerStyles}
    >
      <Box testId="local-dev-banner" xcss={bannerStyles}>
        <Inline alignBlock="center" space="space.100">
          <TerminalIcon label="" />
          {formatMessage(messages.localDevBannerLabel)}
        </Inline>
        {isHovered && (
          <Box xcss={closeButtonStyles}>
            <IconButton
              appearance="subtle"
              icon={(iconProps) => <CrossIcon {...iconProps} size="small" />}
              label="Close"
              onClick={() => setIsHidden(true)}
              shape="circle"
              spacing="compact"
              testId="local-dev-banner-close-button"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
